import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

const API = process.env.REACT_APP_API_URL;

const WARNA = {
  TERSEDIA: { bg: "#dcfce7", fg: "#166534", label: "Bisa diambil" },
  AKTIF: { bg: "#dbeafe", fg: "#1e40af", label: "Kode aktif" },
  TERPAKAI: { bg: "#e5e7eb", fg: "#374151", label: "Sudah dipakai" },
  LEWAT: { bg: "#fee2e2", fg: "#991b1b", label: "Terlewat" },
  BELUM: { bg: "#fef9c3", fg: "#854d0e", label: "Belum mulai" },
};

// Halaman PUBLIK hasil scan barcode kamar: daftar penghuni, sisa hak makan Prasmanan, dan kode sekali pakai.
// Tanpa login — dilindungi token acak per kamar. Mobile-first.
export default function MakanKamarPage() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [kode, setKode] = useState(null); // { PenghuniID, Kode, WaktuNama, BerlakuSampai, Nama }
  const [busy, setBusy] = useState(0);
  const [pesan, setPesan] = useState("");

  const muat = useCallback(() => {
    axios
      .get(API + "makan/kamar/" + encodeURIComponent(token))
      .then((r) => { setData(r.data.data); setError(""); })
      .catch((e) => setError(e.response?.data?.message || "Gagal memuat data kamar"));
  }, [token]);

  useEffect(() => { muat(); const t = setInterval(muat, 60000); return () => clearInterval(t); }, [muat]);

  const minta = async (p) => {
    setBusy(p.PenghuniID); setPesan("");
    try {
      const r = await axios.post(API + "makan/kode", { Token: token, PenghuniID: p.PenghuniID });
      setKode({ ...r.data.data, PenghuniID: p.PenghuniID });
      muat();
    } catch (e) {
      setKode(null);
      setPesan(e.response?.data?.message || "Gagal menerbitkan kode");
    } finally { setBusy(0); }
  };

  if (error) {
    return <div style={{ padding: 24, fontFamily: "sans-serif", textAlign: "center", color: "#991b1b" }}>{error}</div>;
  }
  if (!data) return <div style={{ padding: 24, fontFamily: "sans-serif", textAlign: "center" }}>Memuat…</div>;

  return (
    <div style={{ maxWidth: 480, margin: "0 auto", padding: 16, fontFamily: "system-ui, sans-serif", background: "#f8fafc", minHeight: "100vh" }}>
      <h1 style={{ fontSize: 20, fontWeight: 700, margin: "4px 0" }}>Prasmanan — {data.NamaRoom}</h1>
      <p style={{ fontSize: 13, color: "#64748b", margin: "0 0 12px" }}>
        Pukul {data.Sekarang} WITA. Pilih nama Anda, lalu sebutkan kode ke petugas pantry. Satu kode hanya untuk satu kali makan.
      </p>

      {pesan && <div style={{ background: "#fee2e2", color: "#991b1b", padding: 10, borderRadius: 8, marginBottom: 12, fontSize: 14 }}>{pesan}</div>}

      {data.Penghuni.length === 0 && (
        <div style={{ background: "#fff", padding: 16, borderRadius: 12, border: "1px solid #e2e8f0" }}>Belum ada penghuni aktif di kamar ini.</div>
      )}

      {data.Penghuni.map((p) => (
        <div key={p.PenghuniID} style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 12, padding: 14, marginBottom: 12 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
            <strong style={{ fontSize: 16 }}>{p.Nama}</strong>
            <span style={{ fontSize: 11, color: "#64748b" }}>{p.Jenis === "KLIEN" ? "Klien" : "Karyawan"}</span>
          </div>

          {!p.Berhak ? (
            <p style={{ color: "#991b1b", fontSize: 14, margin: "8px 0 0" }}>{p.Alasan}</p>
          ) : (
            <>
              <p style={{ fontSize: 14, margin: "6px 0" }}>
                Sisa hak hari ini: <strong>{p.SisaHak}</strong> dari {p.TotalHak}
              </p>
              <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 10 }}>
                {p.Hak.map((h) => (
                  <span key={h.WaktuID} style={{ background: WARNA[h.Status].bg, color: WARNA[h.Status].fg, padding: "4px 8px", borderRadius: 8, fontSize: 12 }}>
                    {h.Nama}: {WARNA[h.Status].label}
                  </span>
                ))}
              </div>
              {kode && kode.PenghuniID === p.PenghuniID ? (
                <div style={{ textAlign: "center", background: "#eff6ff", border: "2px dashed #3b82f6", borderRadius: 12, padding: 14 }}>
                  <div style={{ fontSize: 12, color: "#1e40af" }}>Kode {kode.WaktuNama}</div>
                  <div style={{ fontSize: 40, fontWeight: 800, letterSpacing: 6, fontFamily: "monospace" }}>{kode.Kode}</div>
                  <div style={{ fontSize: 12, color: "#64748b" }}>Berlaku sampai {kode.BerlakuSampai}. Sebutkan ke petugas; jangan dibagikan.</div>
                </div>
              ) : (
                <button onClick={() => minta(p)} disabled={busy === p.PenghuniID}
                  style={{ width: "100%", padding: "12px 0", borderRadius: 10, border: 0, background: "#0f766e", color: "#fff", fontSize: 15, fontWeight: 600 }}>
                  {busy === p.PenghuniID ? "Memproses…" : "Tampilkan Kode Makan"}
                </button>
              )}
            </>
          )}
        </div>
      ))}
    </div>
  );
}
